/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChildDto } from '../../models/child-dto';
import { CreateChildDto } from '../../models/create-child-dto';

export interface UserChildControllerCenterCreate$Params {
  centerId: string;
      body: CreateChildDto
}

export function userChildControllerCenterCreate(http: HttpClient, rootUrl: string, params: UserChildControllerCenterCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ChildDto>> {
  const rb = new RequestBuilder(rootUrl, userChildControllerCenterCreate.PATH, 'post');
  if (params) {
    rb.path('centerId', params.centerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChildDto>;
    })
  );
}

userChildControllerCenterCreate.PATH = '/api/child/user/center/{centerId}';
